module.exports = __webpack_public_path__ + "img/user_mind_lookcount.d57ae3a4.svg";